<template>
  <div class="rexer_events__list">
    <div
      v-if="events.length < 1"
      class="rexer_events__content text-center"
    >
      {{ notfound }}
    </div>
    <div
      v-else
      class="rexer_events__content"
    >
      <transition-group
        name="list"
        tag="div"
        class="rexer_events__content-wrap"
      >
        <event-component
          v-for="item in events"
          :key="item.id"
          :event="item"
          :destination="destination"
          @makeReservation="reservationHandle"
        />
      </transition-group>
    </div>
    <!-- ReservationComponent -->
    <reservation-component
      v-if="reservation"
      :data-event="payload"
      @offHandle="offHandle"
    />
    <!-- // ReservationComponent -->
  </div>
</template>

<script>
import EventComponent from './Event.vue'
import ReservationComponent from './Reservation'
export default {
  name: 'Content',
  components: {
    EventComponent,
    ReservationComponent
  },
  props: {
    events: {
      type: Array,
      default: () => ([])
    },
    notfound: {
      type: String,
      default: 'Not Found'
    },
    destination: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      reservation: false,
      payload: null
    }
  },
  methods: {
    reservationHandle ($evt) {
      this.reservation = true
      this.payload = Object.assign({}, $evt)
      document.body.classList.add('rexer-modal-on')
    },
    offHandle ($evt) {
      this.reservation = false
      document.body.classList.remove('rexer-modal-on')
    }
  }
}
</script>
<style lang="scss">
  .list-enter-active, .list-leave-active {
    transition: all 500ms;
  }
  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
  .rexer_events__list {
    position: relative;
    .rexer_reservation {
      box-sizing: border-box;
      position: fixed;
      z-index: 9999;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  body.rexer-modal-on{
    .wrapper_inner > .content, #back_to_top {
      z-index: 1000;
    }
  }

  .rexer_events__content {
    &.text-center {
      text-align: center;
    }
  }

  @media screen and (min-width: 768px) {
    .rexer_events__content {
      &-wrap {
        display: flex;
        flex-direction: row;
        // justify-content: space-around;
        flex-wrap: wrap;
        align-items: flex-start;
        .rexer_event {
          width: 47.5%;
          align-self: flex-start;
          margin-right: 1rem;
          &:nth-child(2n) {
            margin-right: 0
          }
        }
      }
    }
  }
  @media screen and (min-width: 992px) {
    .rexer_events__content {
      &-wrap {
        .rexer_event {
          width: 31.555%;
          &:nth-child(2n) {
            margin-right: 1rem;
          }
          &:nth-child(3n) {
            margin-right: 0
          }
        }
      }
    }
  }
  @media screen and (min-width: 1440px) {
    .rexer_events__content {
      &-wrap {
        .rexer_event {
          width: 32.555%;
        }
      }
    }
  }
</style>
